import "./App.css";
import Navbar from "./components/Navbar";
import React from "react";
import Home from "./components/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CreateTest from "./components/CreateTest";
import Dashboard from "./components/Dashboard";
import SignIn from "./components/SignIn";
import LoadTestMain from "./components/LoadTestMain";
import TestDetails from "./components/TestDetails";
import MyProfile from "./components/MyProfile";
import RagBot from "./components/RagBot";
import RestManStudioCollection from "./components/RestManStudio/RestManStudioCollection";
import RestManStudioEnvironments from "./components/RestManStudio/RestManStudioEnvironments";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/LoadTestMain" element={<LoadTestMain />} />
        <Route path="/CreateTest" element={<CreateTest />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/TestDetails" element={<TestDetails />} />
        <Route path="/MyProfile" element={<MyProfile />} />
        <Route path="/chatBot" element={<RagBot />} />
        <Route
          path="/RestManStudio"
          element={<RestManStudioCollection />}
        />
        <Route
          path="/RestManStudioEnvironments"
          element={<RestManStudioEnvironments />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
